var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorGoldV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1506,
    height: 1505,
    viewBox: "0 0 100 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.0429 67.6386V64.0131L43.2014 49.0125C51.5478 40.7531 58.3485 33.9779 58.3256 33.9439C58.3027 33.91 53.7803 33.8873 48.2619 33.91L38.2326 33.9326V41.5009V49.0578L36.5725 50.7007L34.9123 52.3435V41.4329V30.5337H50.712C59.4018 30.5337 66.5116 30.5677 66.5116 30.6243C66.5116 30.6696 58.6004 38.5325 48.9374 48.0948L31.3632 65.486L31.386 66.6756L31.4204 67.8652L51.9943 67.8992L72.5796 67.9219V53.5558V39.201L76.0143 35.802L79.449 32.4031V29.7973V27.1914L89.7188 37.3655L100 47.5283L76.0143 71.2642L52.0286 95L40.0415 83.1377L28.0429 71.2642V67.6386ZM27.9857 23.7358L51.9714 0L63.9928 11.8962L76.0143 23.7925V27.316V30.8396L60.8902 45.7835C52.5782 53.9976 45.7202 60.8181 45.663 60.9314C45.5599 61.1127 46.0637 61.124 55.6351 61.124H65.7102V53.5671V45.9988L67.3932 44.3333C68.3206 43.4043 69.0877 42.6565 69.1106 42.6565C69.1335 42.6565 69.1449 47.551 69.1449 53.5331V64.4097H53.2651H37.3739L54.9825 46.9845L72.5796 29.5707V28.347V27.1348H51.9714H31.3632V41.5009V55.8557L27.9284 59.2546L24.4937 62.6535V65.2027V67.7519L14.2469 57.6118L4 47.4717L27.9857 23.7358ZM61.5886 80.7812C66.8437 75.5808 71.1141 71.2981 71.0798 71.2642C71.0454 71.2302 62.4129 71.2188 51.9027 71.2302L32.7943 71.2642L42.3542 80.7585C47.6093 85.9702 51.937 90.2415 51.9714 90.2415C52.0057 90.2415 56.3335 85.9815 61.5886 80.7812ZM85.5971 57.0227C90.8408 51.8336 95.1342 47.5283 95.1342 47.4717C95.1342 47.4037 92.1918 44.4466 88.6082 40.9004L82.0823 34.4425L79.0483 37.4448L76.0143 40.4472L76.0372 53.4538L76.0716 66.449L85.5971 57.0227ZM24.986 57.4079L28.0429 54.3828V41.4896C28.0429 34.4085 28.0086 28.6076 27.9513 28.6076C27.9055 28.6076 23.5664 32.8676 18.3113 38.068L8.75134 47.5283L15.2773 53.9863C18.8608 57.5325 21.8261 60.4442 21.8605 60.4442C21.8948 60.4442 23.2916 59.0847 24.986 57.4079ZM71.0912 23.6452C71.0912 23.5206 52.1546 4.81515 52.0286 4.81515C51.9599 4.81515 47.6093 9.07513 42.3542 14.2755L32.7943 23.7358H51.9485C62.4701 23.7358 71.0912 23.7018 71.0912 23.6452Z",
    fill: "#D3A830",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2413_924",
    x: 0,
    y: 0,
    width: 104,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.658824 0 0 0 0 0.188235 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2413_924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2413_924",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorGoldV2);
export default __webpack_public_path__ + "static/media/Vector_gold_v2.a98ed4a3d11dc229cb87e6d6e88e968b.svg";
export { ForwardRef as ReactComponent };